// extracted by extract-css-chunks-webpack-plugin
module.exports = {"expandedNodes":"Node__expandedNodes___2SBhz"};
    if(module.hot) {
      // 1778083487769
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  